import { Redacted, Schema } from "effect";
import { privateDependencyFailure } from "../errors/private-cause.ts";

export const CanonicalJsonFailure = /* @__PURE__ */ (() => {
  class CanonicalJsonFailure extends Schema.TaggedError<CanonicalJsonFailure>()("CanonicalJsonFailure", {
    path: Schema.String, reason: Schema.String, message: Schema.String
  }) {}
  return CanonicalJsonFailure;
})();
export type CanonicalJsonFailure = InstanceType<typeof CanonicalJsonFailure>;
export const CanonicalJsonInputError = /* @__PURE__ */ (() => {
  class CanonicalJsonInputError extends privateDependencyFailure<CanonicalJsonInputError>()("CanonicalJsonInputError", "canonical JSON input") {}
  return CanonicalJsonInputError;
})();
export type CanonicalJsonInputError = InstanceType<typeof CanonicalJsonInputError>;
export type CanonicalJsonError = CanonicalJsonFailure | CanonicalJsonInputError;
export const canonicalInputError = (cause: unknown) => new CanonicalJsonInputError({ cause: Redacted.make(cause) });
export const canonicalRefusal = (path: string, reason: string) => new CanonicalJsonFailure({ path, reason, message: `Value at ${path} ${reason}.` });

export const JsonPrimitive = /* @__PURE__ */ (() => Schema.Union([Schema.Null, Schema.Boolean, Schema.Finite, Schema.String]))();
export type JsonPrimitive = typeof JsonPrimitive.Type;
export const JsonValue = Schema.MutableJson;
export type JsonValue = typeof JsonValue.Type;
export const JsonObject = /* @__PURE__ */ (() => Schema.Record(Schema.String, Schema.mutableKey(JsonValue)))();
export type JsonObject = typeof JsonObject.Type;

// These are staged input boundaries, not recursive eager decoders. Reading an
// accessor or enumerating a child before its predecessor changes the contract.
export const CanonicalScalar = /* @__PURE__ */ (() => Schema.Union([Schema.Null, Schema.Boolean, Schema.String]))();
export const CanonicalArray = /* @__PURE__ */ (() => Schema.declare<unknown[]>(Array.isArray))();
export const CanonicalObject = /* @__PURE__ */ (() => Schema.Unknown.check(Schema.makeFilter(value => typeof value === "object")))();
export const CanonicalPrototype = /* @__PURE__ */ (() => Schema.Unknown.check(Schema.makeFilter(value => value === Object.prototype || value === null)))();
export const CanonicalArrayKey = /* @__PURE__ */ (() => Schema.String.check(Schema.isPattern(/^(0|[1-9][0-9]*)$/)))();
export const CanonicalDataProperty = /* @__PURE__ */ (() => Schema.declare<PropertyDescriptor>(
  (value): value is PropertyDescriptor => !!value && !!(value as PropertyDescriptor).enumerable && "value" in (value as PropertyDescriptor)
))();
